var path = 'app/scripts/modules/core/src/pipeline/config/triggers/travis/selectorTemplate.html';
var html = "<travis-trigger-options command=\"vm.command\"></travis-trigger-options>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/triggers/travis/selectorTemplate.html
// module id = 1030
// module chunks = 0